import { m } from 'motion/react';
import React from 'react';

interface AnimatedSectionProps {
  layoutId: string;
  children: React.ReactNode;
}

/**
 * Wrapper for section content that enables smooth layout animations during reordering.
 * Used in edit mode (design panel) so couples see animated transitions when they
 * reorder, show, or hide website sections. Not used in guest view for performance.
 */
export const AnimatedSection = ({ layoutId, children }: AnimatedSectionProps) => (
  <m.div
    className="relative w-full will-change-transform"
    layout="position"
    layoutId={layoutId}
    initial={false}
    transition={{
      layout: {
        type: 'tween',
        ease: 'easeInOut',
        duration: 0.4,
      },
    }}>
    {children}
  </m.div>
);
